var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSubmit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3184 2.68104C17.234 2.59709 17.1275 2.53896 17.0112 2.5135C16.895 2.48803 16.7739 2.49629 16.6621 2.53729L2.91213 7.53729C2.79355 7.58227 2.69146 7.66226 2.61942 7.76664C2.54737 7.87102 2.50879 7.99484 2.50879 8.12167C2.50879 8.2485 2.54737 8.37232 2.61942 8.4767C2.69146 8.58108 2.79355 8.66107 2.91213 8.70605L8.91214 11.106L11.3121 17.106C11.3572 17.2194 11.4345 17.3171 11.5345 17.3871C11.6344 17.457 11.7527 17.4962 11.8746 17.4998C12.0009 17.4972 12.1235 17.4564 12.2261 17.3828C12.3288 17.3091 12.4067 17.2061 12.4496 17.0873L17.4496 3.3373C17.4922 3.22672 17.5025 3.10631 17.4792 2.99012C17.456 2.87393 17.4002 2.76674 17.3184 2.68104ZM11.8746 15.1248L10.1309 10.7498L13.1246 7.75604L12.2434 6.87479L9.22464 9.89354L4.87463 8.12479L15.8309 4.16855L11.8746 15.1248Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSubmit);
export default __webpack_public_path__ + "static/media/ic-submit.abd1b94ec7cd571198b02b296ee203d9.svg";
export { ForwardRef as ReactComponent };